import { useQuery } from "convex/react";
import { api } from "$convex/convexApi";
import { useAuthIdentity } from "@/contexts/UserProfileContext";

export function useProducts() {
  return useQuery(api.products.listProducts);
}

export function useProductsWithDetails(limit = 500) {
  const { authUserId } = useAuthIdentity();
  return useQuery(
    api.admin.getAllProductsWithDetails,
    authUserId ? { authUserId, limit } : "skip",
  );
}

export function useProduct(productId?: string) {
  return useQuery(
    api.products.getProductById,
    productId ? { productId } : "skip"
  );
}
